import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { filter, map, Observable, switchMap } from 'rxjs';

import { FeatureFlagIds } from './cloud-feature-flags-utils';
import { CloudFeatureFlagsService, FEATURE_FLAG_SERVICE } from './cloud-feature-flags.service';

export function featureFlagEnabledGuard(featureFlagId: FeatureFlagIds): CanActivateFn {
	return (): Observable<boolean | UrlTree> => {
		const featureFlagsService: CloudFeatureFlagsService = inject(FEATURE_FLAG_SERVICE);
		const router = inject(Router);

		// First make sure the feature flag service is done loading, then check the specific feature flag
		return featureFlagsService.isLoading$.pipe(
			filter((isLoading) => !isLoading),
			switchMap(() => featureFlagsService.getFeatureFlag$(featureFlagId)),
			map((isEnabled) => {
				if (isEnabled) return true;
				return router.parseUrl('/');
			})
		);
	};
}
